import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/' || location.pathname === '/home';
    return location.pathname.startsWith(path);
  };

  const initials = (name: string, email: string) => {
    const displayName = name || email.split('@')[0];
    const parts = displayName.split(' ');
    return parts.length >= 2 ? parts[0][0] + parts[1][0] : displayName.slice(0, 2).toUpperCase();
  };

  const NavLinks = () => (
    <>
      <button className={`nav__link ${isActive('/') ? 'active' : ''}`} onClick={() => { navigate('/'); setMobileOpen(false); window.scrollTo(0, 0); }}>
        Home
      </button>
      <button className={`nav__link ${isActive('/members') ? 'active' : ''}`} onClick={() => { navigate('/members'); setMobileOpen(false); window.scrollTo(0, 0); }}>
        Members
      </button>
      <button className={`nav__link ${isActive('/contact') ? 'active' : ''}`} onClick={() => { navigate('/contact'); setMobileOpen(false); window.scrollTo(0, 0); }}>
        Contact
      </button>
      {user && (
        <button className={`nav__link ${isActive('/portal') ? 'active' : ''}`} onClick={() => { navigate('/portal'); setMobileOpen(false); window.scrollTo(0, 0); }}>
          Member Portal
        </button>
      )}
      {user && user.role === 'super_admin' && (
        <button className={`nav__link ${isActive('/portal/admin') ? 'active' : ''}`} onClick={() => { navigate('/portal/admin'); setMobileOpen(false); }}>
          SuperAdmin
        </button>
      )}
    </>
  );

  return (
    <>
      <nav className="nav">
        <div className="nav__inner">
          <div className="nav__logo" onClick={() => navigate('/')}>
            <img src="/RDF_Logo.svg" alt="RDF" className="nav__logo-img" />
          </div>

          <ul className="nav__links">
            <NavLinks />
          </ul>

          <div className="nav__actions desktop">
            {user ? (
              <div className="nav__user-info">
                <div className="nav__avatar">{initials(user.name, user.email)}</div>
                <span style={{maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                  {user.name || user.email.split('@')[0]}
                </span>
                <button className="btn btn-outline-white btn-sm" onClick={() => { logout(); navigate('/'); }}>
                  Sign Out
                </button>
              </div>
            ) : (
              <>
                <button className="btn btn-outline-white btn-sm" onClick={() => navigate('/login')}>
                  Log In
                </button>
                <button className="btn btn-accent btn-sm" onClick={() => navigate('/register')}>
                  Register
                </button>
              </>
            )}
          </div>

          <button className="nav__hamburger" onClick={() => setMobileOpen(v => !v)} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div className={`nav__mobile ${mobileOpen ? 'open' : ''}`}>
        <NavLinks />
        <div className="nav__actions" style={{flexDirection: 'column', gap: 8, marginTop: 8}}>
          {user ? (
            <>
              <div style={{color: 'rgba(255,255,255,.8)', fontSize: 13, padding: '4px 14px'}}>
                Signed in as <strong>{user.email}</strong>
              </div>
              <button className="btn btn-outline-white btn-sm btn-full" onClick={() => { logout(); navigate('/'); setMobileOpen(false); }}>
                Sign Out
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-outline-white btn-sm btn-full" onClick={() => { navigate('/login'); setMobileOpen(false); }}>
                Log In
              </button>
              <button className="btn btn-accent btn-sm btn-full" onClick={() => { navigate('/register'); setMobileOpen(false); }}>
                Register
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};
